"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./Text.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Text =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Text, _PureComponent);

  function Text() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Text)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getUserClassName = function () {
      var className = _this.props.className;
      return className ? className : '';
    };

    _this.getTypeClass = function () {
      var type = _this.props.type;
      var textTypes = ['secondary', 'tertiary', 'quaternary', 'quinary'];
      if (type && textTypes.includes(type)) return "c-Text--".concat(type);
      return '';
    };

    _this.isLightClass = function (light) {
      return light ? "".concat(Text.className, "--light") : '';
    };

    _this.isMutedClass = function (muted) {
      return muted && !_this.props.light ? "".concat(Text.className, "--muted") : '';
    };

    _this.getWeightClassName = function () {
      switch (_this.props.weight) {
        case 'bold':
          return "".concat(Text.className, "--bold");

        case 'light':
          return "".concat(Text.className, "--light-font");

        case 'normal':
          return Text.className;
      }
    };

    _this.getSizeClassName = function () {
      switch (_this.props.size) {
        case 'inherit':
          return "".concat(Text.className, "--inherit-size");

        case 'default':
        default:
          return null;
      }
    };

    _this.getAlignmentClassName = function () {
      if (_this.props.align === 'center') {
        return "".concat(Text.className, "__textAlignCenter");
      } else if (_this.props.align === 'left') {
        return "".concat(Text.className, "__textAlignLeft");
      } else if (_this.props.align === 'right') {
        return "".concat(Text.className, "__textAlignRight");
      } else {
        return '';
      }
    };

    return _this;
  }

  _createClass(Text, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          light = _this$props.light,
          muted = _this$props.muted,
          id = _this$props.id;
      var activeClassNames = [Text.className, this.getUserClassName(), this.isLightClass(light), this.isMutedClass(muted), this.getWeightClassName(), this.getSizeClassName(), this.getTypeClass(), this.getAlignmentClassName()].filter(Boolean).join(' ');
      return _react2.default.createElement("p", {
        className: activeClassNames,
        id: id
      }, children);
    }
  }]);

  return Text;
}(_react.PureComponent);

Text.className = 'c-Text';
Text.defaultProps = {
  light: false,
  muted: false,
  weight: 'normal',
  size: 'default',
  type: '',
  align: '',
  id: null
};
exports.default = Text;